/* src/app/components/billing/ignored-timesheets/ignored-timesheets-data/ignored-timesheets-data.component.css */
.custom-font-size {
  font-size: 14px !important;
}
/*# sourceMappingURL=ignored-timesheets-data.component-VU3VUQLG.css.map */
